<template>
    <PageTitle>
        {{ pageTitle }}
    </PageTitle>
</template>

<script>
import administerRecord from './../administer-record';

const component = administerRecord();

export default {
    mixins: [component],

    setup(props, context) {
        if (component.setup) {
            return component.setup(props, context);
        }

        return {}
    }
}
</script>
